import React from "react";

// Material components
import { SvgIcon } from "@material-ui/core";
export default function PeopleBetaIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <rect
        xmlns="http://www.w3.org/2000/svg"
        x="2"
        y="16"
        width="20"
        height="7"
        rx="3.5"
        fill="white"
      />
      <path d="M5.7 3.6C5.7 2.64522 6.07928 1.72955 6.75442 1.05442C7.42955 0.379285 8.34522 0 9.3 0C10.2548 0 11.1705 0.379285 11.8456 1.05442C12.5207 1.72955 12.9 2.64522 12.9 3.6C12.9 4.55478 12.5207 5.47045 11.8456 6.14558C11.1705 6.82072 10.2548 7.2 9.3 7.2C8.34522 7.2 7.42955 6.82072 6.75442 6.14558C6.07928 5.47045 5.7 4.55478 5.7 3.6ZM3 13.5647C3 10.7944 5.24438 8.55 8.01469 8.55H10.5853C13.3556 8.55 15.6 10.7944 15.6 13.5647C15.6 14.0259 15.2259 14.4 14.7647 14.4H3.83531C3.37406 14.4 3 14.0259 3 13.5647ZM20.1366 14.4H16.2581C16.41 14.1356 16.5 13.8291 16.5 13.5V13.275C16.5 11.5678 15.7378 10.035 14.5369 9.00562C14.6044 9.00281 14.6691 9 14.7366 9H16.4634C18.9694 9 21 11.0306 21 13.5366C21 14.0147 20.6119 14.4 20.1366 14.4ZM15.15 7.2C14.2781 7.2 13.4906 6.84562 12.9197 6.27469C13.4737 5.52656 13.8 4.60125 13.8 3.6C13.8 2.84625 13.6144 2.13469 13.2853 1.51031C13.8084 1.12781 14.4525 0.9 15.15 0.9C16.8909 0.9 18.3 2.30906 18.3 4.05C18.3 5.79094 16.8909 7.2 15.15 7.2Z" />
      <path
        d="M18.246 17.7998L19.89 21.9998H18.966L18.63 21.1718H17.004L16.674 21.9998H15.75L17.394 17.7998H18.246ZM17.82 19.0118L17.298 20.3798H18.342L17.82 19.0118Z"
        fill="#182028"
      />
      <path
        d="M12.7988 17.7998H16.0988V18.6218H14.8928V21.9998H14.0048V18.6218H12.7988V17.7998Z"
        fill="#182028"
      />
      <path
        d="M9.13672 21.9998V17.7998H12.2387V18.6218H10.0307V19.4498H12.1367V20.2598H10.0307V21.1778H12.2387V21.9998H9.13672Z"
        fill="#182028"
      />
      <path
        d="M5 21.9998V17.7998H6.89C7.318 17.7998 7.666 17.8978 7.934 18.0938C8.206 18.2858 8.342 18.5738 8.342 18.9578C8.342 19.1178 8.304 19.2738 8.228 19.4258C8.152 19.5778 8.046 19.7058 7.91 19.8098C8.102 19.9458 8.238 20.0938 8.318 20.2538C8.402 20.4098 8.444 20.5818 8.444 20.7698C8.444 21.1378 8.31 21.4358 8.042 21.6638C7.778 21.8878 7.428 21.9998 6.992 21.9998H5ZM5.894 21.1778H6.788C7.016 21.1778 7.198 21.1438 7.334 21.0758C7.474 21.0038 7.544 20.8758 7.544 20.6918C7.544 20.5198 7.476 20.3998 7.34 20.3318C7.204 20.2638 7.028 20.2298 6.812 20.2298H5.894V21.1778ZM6.71 18.6218H5.894V19.4798H6.746C6.986 19.4798 7.162 19.4438 7.274 19.3718C7.386 19.2958 7.442 19.1878 7.442 19.0478C7.442 18.8878 7.382 18.7778 7.262 18.7178C7.146 18.6538 6.962 18.6218 6.71 18.6218Z"
        fill="#182028"
      />
    </SvgIcon>
  );
}
